import React from "react";
import { Navigate } from "react-router-dom";
import { getStoredSession } from "../mmtUserList/mmtFlow";
import { isWebView } from "../../utlis/webViewBridge";

export default function RequireSession({ children }) {
  if (isWebView()) return children;
  const session = getStoredSession();
  if (!session) return <Navigate to="/login" replace />;
  return children;
}
